import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AdminBottomNav from './AdminBottomNav';
import MemberBottomNav from './MemberBottomNav';

const BottomNavigation = () => {
  const { currentUser } = useAuth();

  // Render different navigation bar based on user role
  const isAdmin = currentUser?.role === 'admin';

  return isAdmin ? <AdminBottomNav /> : <MemberBottomNav />;
};

export default BottomNavigation;